export const ACCESS_TOKEN = "accessToken";
export const CODE_CHALLENGE = "codeChallenge";
export const CODE_VERIFIER = "codeVerifier";
export const EXPIRES_AT = "expiresAt";
export const ID_TOKEN = "idToken";
export const OPENID_SCOPE = "email openid";
export const PROFILE = "profile";
export const REFRESH_TOKEN = "refreshToken";
export const USER_INFO = "userInfo";
